<div class="gl-dashboard__header">
  <div class="gl-dashboard__title">
    <span>{{ 'dashboard.widgets.autoevaluation' | translate }}</span>
    <button
      type="button"
      lmsTooltip
      [tooltipConfig]="{
        positionV: 'top',
        positionH: 'center',
        text: ['dashboard.widgets.autoevaluationTooltip' | translate]
      }"
      class="un-btn"
    >
      <span class="glicon-info"></span>
    </button>
  </div>
</div>
<div *ngIf="!autoevaluationData" class="gl-dashboard__void">
  <span>{{ 'dashboard.widgets.notEvaluation' | translate }}</span>
</div>
<div *ngIf="autoevaluationData">
  <div class="gl-dashboard__row--grid">
    <div class="gl-dashboard__info">
      <span class="title">{{ 'dashboard.widgets.beforeMedia' | translate }}</span>
      <span class="value">{{ autoevaluation.avgResponsesInitial | number : '1.0-1' }}</span>
    </div>
    <div class="gl-dashboard__info">
      <span class="title">{{ 'dashboard.widgets.afterMedia' | translate }}</span>
      <span class="value">{{ autoevaluation.avgResponsesFinal | number : '1.0-1' }}</span>
    </div>

    <div class="gl-dashboard__info">
      <span class="title">{{ 'dashboard.widgets.improve' | translate }}</span>
      <span class="value" [ngClass]="autoevaluation.avgGlobal >= 0 ? 'success' : 'failed'">
        {{ autoevaluation.avgGlobal | number : '1.0-0' }}%
      </span>
    </div>
    <div class="gl-dashboard__info">
      <span class="title">{{ 'dashboard.widgets.responseNumber' | translate }}</span>
      <span class="value">{{ autoevaluation.surveysCount | number : '1.0-1' }}</span>
    </div>
  </div>
</div>
